import useRequest from '@space-shell/common/hooks/useRequest'
import {
  CONTEXT,
  NotificationsEndpoints,
  NotificationsService,
  ROLE
} from '@space-shell/common/services/notifications'

export const useNotificationCountRequest = () => {
  return useRequest([NotificationsEndpoints.count()], () =>
    NotificationsService.getCount({ role: ROLE.CONSUMER, context: CONTEXT.CLUB })
  )
}
